// Vendor imports
const { connect } = require('react-redux')
// Common ClientV2 imports
const deferDispatch = require('client-v2/common/state/dispatch')
const routerActions = require('client-v2/common/state/router/actions')
const searchActions = require('client-v2/common/state/search/actions')
const ConnectAuthModalActions = require('client-v2/common/containers/auth-modal/actions-component')
// Container imports
const LandingHeader = require('./component-dumb')

function mapDispatchToProps(dispatch) {
  const { dispatchAction } = deferDispatch(dispatch)
  return Object.assign({
    onSearchNavigate: dispatchAction(routerActions.navigate),
    onSearchSubmit: dispatchAction(searchActions.navigateToArticleSearch)
  }, ConnectAuthModalActions.mapDispatchToProps(dispatch))
}

module.exports = connect(
  ConnectAuthModalActions.mapStateToProps,
  mapDispatchToProps
)(
  LandingHeader
)
